import { IntlShape } from 'react-intl';
import { formatDecimal, formatInt, HourPoint, Measure, measureValue } from './statisticsUtils';

/** Los 7 días de la semana, de lunes a domingo, con los nombres de `es.json`. */
export function weekdayNames(intl: IntlShape): string[] {
    return Array.from({ length: 7 }, (_, index) => intl.formatMessage({ id: `ServicesStatisticsWeekday${index + 1}` }));
}

/** El valor de una hora (o de un día y hora) en la medida elegida, con las atenciones que lo respaldan. */
export function hourValueText(intl: IntlShape, point: HourPoint, measure: Measure): string {
    const value = measureValue(point, measure);
    if (value === null) return intl.formatMessage({ id: 'ServicesStatisticsNoAttentions' });
    const values = { value: formatDecimal(value), total: formatInt(point.attentions) };
    return intl.formatMessage(
        { id: measure === 'attentions' ? 'ServicesStatisticsHourPerDay' : 'ServicesStatisticsHourMinutes' }, values);
}
